import { render, staticRenderFns } from "./TenantBuildingInfo.vue?vue&type=template&id=b1ad7fea&scoped=true&"
import script from "./TenantBuildingInfo.vue?vue&type=script&lang=js&"
export * from "./TenantBuildingInfo.vue?vue&type=script&lang=js&"
import style0 from "./TenantBuildingInfo.vue?vue&type=style&index=0&id=b1ad7fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ad7fea",
  null
  
)

export default component.exports